
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/google",
      function () {
        return require("private-next-pages/google.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/google"])
      });
    }
  